import { Tag, Colors } from "@blueprintjs/core";
import styled from "styled-components";
const CustomTag = styled(Tag)<{ bgColor?: string; color?: string; theme: { darkMode?: boolean } }>`
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 3px 10px;
  border-radius: 10px;
  background-color: ${({ bgColor, theme: { darkMode } }) =>
    bgColor ? bgColor : darkMode ? Colors.DARK_GRAY2 : Colors.GRAY5};
  color: ({ color, theme: { darkMode } }) =>
    color ? color : darkMode ? Colors.WHITE : Colors.DARK_GRAY2};
  font-size: 12px;
`;

export default CustomTag;
